export const types = {
  SET_LABELS: "SET_LABELS",
  ADD_LABEL: "ADD_LABEL",
  UPDATE_LABEL: "UPDATE_LABEL",
  DELETE_LABEL: "DELETE_LABEL",
};

export const setLabels = payload => ({
  type: types.SET_LABELS,
  payload,
});

export const addLabel = payload => ({
  type: types.ADD_LABEL,
  payload,
});

export const updateLabel = payload => ({
  type: types.UPDATE_LABEL,
  payload,
});

export const deleteLabel = payload => ({
  type: types.DELETE_LABEL,
  payload,
});
